import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Hero.css';
import './AudienceSwitch.css';

const PANEL_URL = 'https://panel.tenkusports.com';

const VenuesBand = () => {
  const { t } = useTranslation();

  return (
    <section className="tk-venues-band">
      <div className="tk-venues-band-card">
        <div>
          <p className="tk-venues-band-eyebrow">{t('venuesBand.eyebrow')}</p>
          <h2 className="tk-venues-band-title">{t('venuesBand.title')}</h2>
          <p className="tk-venues-band-text">{t('venuesBand.text')}</p>
        </div>
        <div className="tk-venues-band-actions">
          <Link to="/venues" className="tk-btn-primary">{t('venuesBand.cta')}</Link>
          <a href={PANEL_URL} className="tk-btn-ghost">{t('venuesBand.login')}</a>
        </div>
      </div>
    </section>
  );
};

export default VenuesBand;
